import React from 'react';
import { ColorPicker } from '../../../../../components/ColorPicker';
import { PdfComponentBorderProperties } from '../../../PdfComponent';
import { PdfComponentWithBorder } from '../PdfTemplateComponentBorder';

export default function PdfTemplateComponentBorderColor({
  component,
  updateBorder,
}: {
  component: PdfComponentWithBorder;
  updateBorder: (border: Partial<PdfComponentBorderProperties>) => void;
}) {
  return (
    <ColorPicker
      label={'Border color'}
      color={component.border.color}
      onChange={color => updateBorder({ color })}
      tooltip={'Select border color'}
    />
  );
}
